import Paragraph from 'Root/App/Paragraph'
import Title from 'Root/App/Title'

import styles from '../index.module.css'

const Avatar = ({ url }) => {
  return (
    <div className={styles.avatarWrapper}>
      <img src={url} alt={url} />
    </div>
  )
}

const ReviewComment = ({ author, created_at, content }) => {
  return (
    <div className={styles.reviewCommentWrapper}>
      <Avatar url={`https://ui-avatars.com/api/?name=${author}`} />
      <div>
        <div className={styles.reviewCommentHeader}>
          <Title size="XS">{author}</Title>
          <Paragraph
            className={styles.reviewCommentDate}
          >{` · ${created_at}`}</Paragraph>
        </div>
        <Paragraph>{content}</Paragraph>
      </div>
    </div>
  )
}

export default ReviewComment
